export const TASK_THREAD_TITLE = 'Activity';
